import { serviceHistoryApi } from '@/lib/api/service-history.api';

/**
 * Open a signed URL in a new tab. The tab is opened before the URL request so
 * the browser doesn't treat it as a blocked pop-up.
 */
const openInNewTab = async (getUrl: () => Promise<string>) => {
  const tab = window.open('', '_blank');
  try {
    const url = await getUrl();
    if (tab) tab.location.href = url;
    else window.open(url, '_blank');
  } catch {
    tab?.close();
  }
};

export const openServiceDocument = (documentId: string) =>
  openInNewTab(() => serviceHistoryApi.getDocumentUrl(documentId));

/** The current summary as the customer-facing PDF. */
export const openSummaryPdf = (vehicleId: string) =>
  openInNewTab(() => serviceHistoryApi.getSummaryPdfUrl(vehicleId));
